export const HttpRequestHeaders = {
  DASHBOARD_PLATFORM_ID: 'new-dashboard',
  GUEST_AUTH_TOKEN: 'X-Guest-Auth-Token',
};
